import React from 'react';
import { Form, Field, reduxForm } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import ButtonLiquidPrimary from 'components/atoms/buttons/liquid/Primary';
import LoginButtonWrapper from 'components/atoms/form/LoginButtonWrapper';
import LoginLinkWrapper from 'components/atoms/form/LoginLinkWrapper';
import LoginLink from 'components/atoms/form/LoginLink';
import TextInput from 'components/atoms/inputs/TextInput';
import { submitResetPasswordForm } from 'services/auth/duck';

const InstructionText = styled.p`
    font-size: 16px;
`;

const ResetPasswordForm = props => (
    <Form onSubmit={props.handleSubmit(submitResetPasswordForm)} id="setPasswordForm">
        <InstructionText>Enter your email to reset your password</InstructionText>
        <Field component={TextInput} name="email" label="EMAIL" type="text" />
        <Row>
            <Col xs={12} sm={6}>
                <LoginButtonWrapper>
                    <ButtonLiquidPrimary type="submit">RESET PASSWORD</ButtonLiquidPrimary>
                </LoginButtonWrapper>
            </Col>
            <Col xs={12} sm={6}>
                <LoginLinkWrapper>
                    <LoginLink to="/login">Return to Sign In</LoginLink>
                </LoginLinkWrapper>
            </Col>
        </Row>
    </Form>

);

export default reduxForm({
    form: 'reset-password'
})(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/organisms/forms/ResetPassword.js